module.exports = __webpack_public_path__ + "img/bg_lobby_top.e2c6da97.png";